'use strict';

class SidemenuController {
    /* @ngInject */
    constructor($mdSidenav) {
        Object.assign(this, {$mdSidenav});
    }

    $onInit() {
    }

    toggleSidemenu(id) {
        this.$mdSidenav(id)
            .toggle();
    }

    toggle(name) {
        if (this.toggledItem === name) {
            this.toggledItem = null;
        } else {
            this.toggledItem = name;
        }
    }

}

export default SidemenuController;
